module.exports = __webpack_public_path__ + "img/gengduo.a19670da.png";